import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import heTranslation from './locales/he/translation.json';
import arTranslation from './locales/ar/translation.json';
import nlTranslation from './locales/nl/translation.json';
import { getCurrentLanguage, getLegacyLanguage, removeLegacyLanguage, removeLegacyDirection, removeCurrentLanguage } from '../services/localStorage';

const EN_LOCALE = 'en';
const HE_LOCALE = 'he';
const AR_LOCALE = 'ar';
const NL_LOCALE = 'nl';

const EN_US_LOCALE = 'en-US';
const EN_GB_LOCALE = 'en-GB';
const HE_IL_LOCALE = 'he-IL';
const AR_SA_LOCALE = 'ar-SA';
const AR_EG_LOCALE = 'ar-EG';
const NL_NL_LOCALE = 'nl-NL';

const HEB_LOCALE = 'heb';
const ENG_LOCALE = 'eng';
const ARA_LOCALE = 'ara';

const ISR_SIGN = 'isr';
const AOS_SIGN = 'aos';
const INT_SIGN = 'is';

const RTL_DIRECTION = 'rtl';
const LTR_DIRECTION = 'ltr';

const DEFAULT_LANGUAGE = EN_LOCALE;

const getBrowserLanguage = (): string | null => {
  if (navigator && navigator.language) {
    return navigator.language.split('-')[0];
  }
  return null;
};

const getStoredLanguage = (): string | null => {
  return getCurrentLanguage();
};

const validLanguages: string[] = [EN_LOCALE, HE_LOCALE, AR_LOCALE, NL_LOCALE, NL_NL_LOCALE];

const storedXsiteLanguage = getLegacyLanguage();
if (storedXsiteLanguage && !validLanguages.includes(storedXsiteLanguage)) {
  removeLegacyLanguage();
  removeLegacyDirection();
}

const storedCurrLanguage = getCurrentLanguage();
if (storedCurrLanguage && !validLanguages.includes(storedCurrLanguage)) {
  removeCurrentLanguage();
}

const storedLanguage = getStoredLanguage();
const browserLanguage = getBrowserLanguage();
const initialLanguage = storedLanguage || browserLanguage || DEFAULT_LANGUAGE;

i18n
  .use(initReactI18next)
  .init({
    resources: {
      [EN_LOCALE]: { translation: enTranslation },
      [HE_LOCALE]: { translation: heTranslation },
      [AR_LOCALE]: { translation: arTranslation },
      [NL_LOCALE]: { translation: nlTranslation },
      [NL_NL_LOCALE]: { translation: nlTranslation },
    },
    lng: initialLanguage,
    fallbackLng: DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: true,
    },
    react : {
      transSupportBasicHtmlNodes: true,
    }
  });

export { 
  EN_LOCALE, 
  HE_LOCALE, 
  AR_LOCALE, 
  NL_LOCALE, 
  EN_US_LOCALE, 
  EN_GB_LOCALE,
  HE_IL_LOCALE, 
  AR_SA_LOCALE, 
  AR_EG_LOCALE,
  NL_NL_LOCALE,
  HEB_LOCALE,
  ENG_LOCALE,
  ARA_LOCALE,
  ISR_SIGN,
  AOS_SIGN,
  INT_SIGN,
  RTL_DIRECTION,
  LTR_DIRECTION
};
export default i18n;
